import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatter } from '@jms/model';

@Pipe({
    name: 'currencyFormat',
    standalone: true
})
export class CurrencyFormatPipe implements PipeTransform {

    constructor() { }

    public transform(value: number | string, round: string = '2', zeroIfNull = true): string {

        let price = typeof value === 'number'
            ? value
            : Number(value)

        if (!zeroIfNull && (value === null || value === undefined || value === '')) {
            return '―';
        } else if (!price) {
            price = 0;
        }

        return CurrencyFormatter.formatCurrency(price, Number(round));
    }
}
